import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 z-0" }
const _hoisted_2 = { class: "border bg-white rounded-lg p-4 shadow-xl mx-4 sm:mx-0 w-full max-w-96 z-50" }
const _hoisted_3 = { class: "font-bold text-gray-900" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_5 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_6 = {
  key: 2,
  class: "text-gray-500 mb-2"
}
const _hoisted_7 = {
  key: 3,
  class: "text-gray-500"
}
const _hoisted_8 = {
  key: 4,
  class: "text-gray-500"
}

import {
		InformationCircleIcon
	} from '@heroicons/vue/24/outline'
	import { 
		Popover, 
		PopoverButton, 
		PopoverPanel, 
		TransitionRoot 
	} from '@headlessui/vue'
	import {
		ref
	} from 'vue'

	
// name the component
	const __default__ = { name: 'ContractorPopover' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		contractor: {
			type: Object,
			default: Object
		}
	},
  setup(__props) {

const props = __props;


	const hover = ref(false)
	

	const hasAddress = ref<Boolean>( 
		contractorHasAddress()
	)

	function contractorHasAddress(){
		try{
			var hasAddress = props.contractor?.mailingAddress && props.contractor?.mailingCity && props.contractor?.mailingState && props.contractor?.mailingZip
		}
		catch(e){
			return false
		}
		return hasAddress
	}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Popover), { class: "h-6" }, {
      default: _withCtx(() => [
        _createVNode(_unref(PopoverButton), {
          class: "outline-none cursor-default z-0",
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (hover.value = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hover.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(InformationCircleIcon), { class: "z-0 h-6 text-brand-500" })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(PopoverPanel), {
          class: "absolute z-10 w-screen pr-8 left-0 sm:pr-0 sm:w-96 sm:left-auto",
          static: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionRoot), {
              show: hover.value,
              class: "z-10 w-full",
              enter: "transition-opacity duration-75",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity duration-150",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(__props.contractor?.name), 1),
                  (hasAddress.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.contractor?.mailingAddress), 1))
                    : _createCommentVNode("", true),
                  (hasAddress.value && __props.contractor?.mailingAddress2)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.contractor?.mailingAddress2), 1))
                    : _createCommentVNode("", true),
                  (hasAddress.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.contractor?.mailingCity) + " , " + _toDisplayString(__props.contractor?.mailingState) + " " + _toDisplayString(__props.contractor?.mailingZip), 1))
                    : _createCommentVNode("", true),
                  (__props.contractor?.phone)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.contractor?.phone), 1))
                    : _createCommentVNode("", true),
                  (__props.contractor?.email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.contractor?.email), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})